export const MOOD_OPTIONS = [
  'Calm',
  'Lonely',
  'Warm',
  'Hidden',
  'Noisy',
  'Safe',
  'Melancholic',
  'Alive',
  'Excited',
  'Peaceful',
  'Mysterious',
  'Busy',
  'Romantic',
  'Creative',
  'Spooky',
  'Funny',
  'Inspiring',
  'Chaotic',
  'Nostalgic',
  'Dreamy',
  'Energetic',
  'Triumphant',
  'Focused',
  'Friendly',
];

export const PIN_STYLES = [
  { id: 'default', name: 'Classic', color: 'from-blue-500 to-blue-600', icon: '📍' },
  { id: 'heart', name: 'Heart', color: 'from-rose-500 to-pink-600', icon: '❤️' },
  { id: 'star', name: 'Star', color: 'from-amber-500 to-yellow-600', icon: '⭐' },
  { id: 'fire', name: 'Fire', color: 'from-orange-500 to-red-600', icon: '🔥' },
  { id: 'leaf', name: 'Nature', color: 'from-green-500 to-emerald-600', icon: '🍃' },
  { id: 'moon', name: 'Night', color: 'from-indigo-500 to-purple-600', icon: '🌙' },
  { id: 'coffee', name: 'Coffee', color: 'from-amber-700 to-orange-800', icon: '☕' },
  { id: 'party', name: 'Party', color: 'from-purple-500 to-pink-500', icon: '🎉' },
  { id: 'music', name: 'Music', color: 'from-fuchsia-500 to-rose-500', icon: '🎵' },
  { id: 'food', name: 'Food', color: 'from-orange-400 to-red-500', icon: '🍔' },
  { id: 'basketball', name: 'Basket', color: 'from-orange-500 to-amber-600', icon: '🏀' },
  { id: 'soccer', name: 'Football', color: 'from-emerald-500 to-green-600', icon: '⚽' },
  { id: 'gym', name: 'Workout', color: 'from-slate-500 to-slate-600', icon: '💪' },
  { id: 'gaming', name: 'Gaming', color: 'from-violet-500 to-purple-600', icon: '🎮' },
  { id: 'study', name: 'Study', color: 'from-sky-500 to-blue-600', icon: '📚' },
];
